import { Injectable } from '@angular/core';
import { FavoriteServiceBase } from '@bases/favorite-service/favorite-service.base';
import { ModelOffer } from '@models/model-offer';

@Injectable({
  providedIn: 'root'
})
export class FavoriteModelOfferService extends FavoriteServiceBase<ModelOffer> {
  constructor() {
    super('model_offer_favorites');
  }
}
